import { SvgIcon } from '@mui/material';

const ProduceIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M15.24 5.9a3.85 3.85 0 0 1-.7 2.25 4.6 4.6 0 0 1-1.15-.85 3.55 3.55 0 0 1-1.15-2.4 4.3 4.3 0 0 1-2.45-1.15 3.9 3.9 0 0 1-.8-1.2 4.25 4.25 0 0 1 2.25-.65 3.75 3.75 0 0 1 1.65.35 4.1 4.1 0 0 1 2 2 4.4 4.4 0 0 1 .35 1.65Z"
          stroke="currentColor"
        />
        <path
          d="M13.84 2.85s1.2.15 1.7-1.35M8.39 5.2a11.2 11.2 0 0 1-4.95 3.45c-2.8.95-2.25 5.65 1.4 5.7s5-1.25 7.25-5.05"
          stroke="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default ProduceIcon;
